import React, { useState } from "react"
import { useStaticQuery, graphql } from "gatsby"
import Img from "gatsby-image"
import styled from "styled-components"

import Search from "./Search"
import Message from "./Message"


const Wrapper = styled.div`
  width: 290px;
  @media screen and (max-width: 950px) {
    display: none;
  }
`

const SearchWrapper = styled.div`
  margin-bottom: 10px;
  padding: 20px;
  background: ${({ theme }) => theme.background.paper};
  ${({ theme }) => theme.dp.one};
`

const AssistantWrapper = styled.div`
  display: flex;
  img {
    user-select: none;
    pointer-events: none;
  }
`

const MessageWrapper = styled.div`
	position: relative;
	display: flex;
	justify-content: center;
	align-items: center;
  width: 190px;
  margin: 15px;
	padding: 10px;
  border-radius: 5px;
  background: ${({ theme }) => theme.background.paper};
  ${({ theme }) => theme.dp.one};
	color: ${({ theme }) => theme.text.post};
	font-size: .9em;
	text-align: center;
	::before, ::after {
		position: absolute;
    top: 10px;
    border-width: 10px;
    border-color: transparent ${({ theme }) => theme.Assist.background};
		content: "";
	} 
  ::before {
    right: -10px;
    border-style: solid none solid solid;
  }
  ::after {
    right: -7px;
    border-style: solid none solid solid;
  }
`

const IsANDChanger = styled.div`
	margin-bottom: 10px;
	vertical-align: middle;
  input {
  	display: none;
		margin: auto 0;
		:checked + .isAnd {
    	background: rgb(153, 153, 153);
			::before {
				transform: translateX(100%);
    		transition: all 0.3s ease;
			}
		}
	}
  .isAnd {
		position: relative;
    display: inline-block;
   	width: 40px;
    height: 10px;
		border-radius: 30px;
    background: rgb(99, 99, 99);
		cursor: pointer;
		::before {
			position: absolute;
			display: block;
			top: -5px;
    	left: 0;
			z-index: 100;
			width: 20px;
    	height: 20px;
    	border-radius: 50%;
    	background: rgba(189, 189, 189);
			transition: all 0.3s ease;
			content: "";
		}
  }
	.switchSearch {
    margin-left: 10px;
    line-height: 20px;
    vertical-align: middle;
		user-select: none;
	}
`

const Assist = () => {
  const data = useStaticQuery(graphql`
    query AssistQuery {
      image: file(relativePath: {regex: "/assist/defaultAssist.png/"}) {
        childImageSharp {
          fixed (width: 100, height: 100){
            ...GatsbyImageSharpFixed_withWebp
          }
        }
      }
    }
  `)
  const AssistImg = data.image.childImageSharp.fixed

	const [HitsCount, setHitsCount] = useState(null)
	const handleHitsCount = (count) => {
		setHitsCount(count)
	}

	const [isAND, setIsAND] = useState(true)
	const handleIsAND = () => {
		setIsAND(!isAND)
	}

  return (
    <Wrapper>
      <SearchWrapper>
        <IsANDChanger>
          <input
            id="isAnd"
            type="checkbox"
            checked={isAND}
            onChange={handleIsAND}
          />
          <label className="isAnd" htmlFor="isAnd" />
          <label for="switchSearch" className="switchSearch">{isAND ? <>AND検索</> : <>OR検索</>}</label>
        </IsANDChanger>
        <Search
          handleHitsCount={handleHitsCount}
          isAND={isAND}
        />
      </SearchWrapper>
      <AssistantWrapper>
        <MessageWrapper>
          <Message
            HitsCount={HitsCount}
          />
        </MessageWrapper>
        <Img
          fixed={AssistImg}
          alt="assist"
          aria-label="assist"
        />
      </AssistantWrapper>
    </Wrapper>
  )
}

export default Assist